import { Status } from "@/types/Status"
import { Dayjs } from "dayjs"
import { IJuniferFile, JunCommStatusText } from "./juniferComm.parser"
import { IJuniferComm } from "./juniferComm.types"

export class JuniferComm implements IJuniferComm {
  id: number
  type: string
  createdDate: Dayjs
  statusText: JunCommStatusText
  files: IJuniferFile[]

  constructor(
    id: number,
    type: string,
    createdDate: Dayjs,
    status: JunCommStatusText,
    files: IJuniferFile[],
  ) {
    this.id = id
    this.type = type
    this.createdDate = createdDate
    this.statusText = status
    this.files = files
  }

  // Junifer created the communication but produced no email or letter, so the
  // customer received nothing and there's no content to fetch.
  get hasNoDeliveries(): boolean {
    return this.statusText === "NoDeliveries"
  }

  // Junifer tried to send the communication and failed, so the customer didn't
  // receive it.
  get hasFailed(): boolean {
    return this.statusText === "Failed"
  }

  get status(): Status {
    switch (this.statusText) {
      case "Successful":
      case "SuccessfulWithWarnings":
        return new Status("normal", this.statusText)
      case "Pending":
        return new Status("caution", this.statusText)
      case "Failed":
        return new Status("critical", this.statusText)
      default:
        return new Status("default", this.statusText)
    }
  }
}
